/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import InfoContact from "./InfoContact";
import { MapBoxGiaLoc } from "./Mapbox";
import BasicLayout from "../../layouts/BasicLayout";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="mt-8">
      <BasicLayout>
        <div className="w-1180 mb-8">
          <div className="grid grid-cols-2 gap-5">
            <div className="col-span-2 lg:col-span-1">
              <div className="mb-8">
                <h1 className="mb-3 font-bold text-[20px] underlined-40 relative inline-block">
                 Nấu Cỗ 34 Hải Dương
                </h1>
                <InfoContact />
              </div>

              <div className="">
                <h1 className="mb-3 font-bold text-[20px] underlined-40 relative inline-block">
                  Liên hệ với chúng tôi
                </h1>
                <span className="p-2 block text-sm font-medium">
                  Nếu bạn có thắc mắc gì, có thể gửi yêu cầu cho chúng tôi, và
                  chúng tôi sẽ liên lạc lại với bạn sớm nhất có thể .
                </span>
                <div className="p-2">
                  <li className="flex  gap-3 flex-col mb-5">
                    <Link className="flex items-center gap-5 text-sm  underline w-fit" to={"https://zalo.me/0584564666"}>
                      <img
                        className="hover:opacity-80 transition"
                        width="32px"
                        src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/zalo.png?1700209535143"
                      ></img>
                      <span>https://zalo.me/0584.564.666</span>
                    </Link>
                    <Link className="flex items-center gap-5 text-sm underline w-fit"
                      to={
                        "https://www.facebook.com/profile.php?id=61559704733274"
                      }
                    >
                      <img
                        className="hover:opacity-80 transition"
                        width="32px"
                        src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/facebook.png?1700209535143"
                      ></img>
                      <span>https://fabook/nau-co-34-hai-duong</span>
                    </Link>

                    <Link className="flex items-center gap-5 text-sm underline w-fit" to="https://mail.google.com/mail/u/0/#inbox">
                      <img
                        className="hover:opacity-80 transition"
                        width="32px"
                        src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/google.png?1700209535143"
                      ></img>
                      <div> https://mail.google.com/mail/u/0/#inbox</div>
                    </Link>
                    <a href="tel:0584564666" className="flex items-center gap-5 text-sm underline w-fit" >
                      <img
                        className="hover:opacity-80 transition"
                        width="32px"
                        src="https://static.vecteezy.com/system/resources/previews/017/732/782/non_2x/green-telephone-icon-telephone-icon-ai-format-free-vector.jpg"
                      ></img>
                      <div>0584.564.666</div>
                    </a>
                  </li>
                </div>
              </div>
            </div>

            <div className="col-span-2 lg:col-span-1">
              <MapBoxGiaLoc />
            </div>
          </div>
        </div>
      </BasicLayout>
    </div>
  );
};

export default Contact;
